"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = __importDefault(require("debug"));
var debug = (0, debug_1.default)("@staffbar/client:API");
/**
 * The API class is the main entry point for interacting with the StaffBarServer
 * embedded in your application
 *
 */
var API = /** @class */ (function () {
    function API(_a) {
        var tokenProvider = _a.tokenProvider;
        this.lastUpdatedPreferences = null;
        this.tokenProvider = tokenProvider;
    }
    /**
     * POST - /api/staffbar/context
     *
     * @param input The context request input
     * @returns The resolved context
     */
    API.prototype.getContextAndBar = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                debug("getContextAndBar", input);
                return [2 /*return*/, this._fetch("/api/staffbar/context", {
                        method: "POST",
                        body: JSON.stringify(input),
                    })];
            });
        });
    };
    /**
     * POST - /api/staffbar/user
     *
     * @param input The userPerference request input
     * @returns The resolved userPreferences context
     */
    API.prototype.updateUserPreferences = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                debug("updateUserPreferences", input);
                Object.keys(input.userPreferences).forEach(function (key) {
                    var _a;
                    if (input.userPreferences[key] === (((_a = _this.lastUpdatedPreferences) === null || _a === void 0 ? void 0 : _a.userPreferences) || {})[key]) {
                        delete input.userPreferences[key];
                    }
                });
                debug("updateUserPreferences - with removed keys", Object.keys(input.userPreferences).length, input);
                if (Object.keys(input.userPreferences).length === 0) {
                    return [2 /*return*/, {
                            ok: true,
                            value: __assign(__assign({}, (this.lastUpdatedPreferences || {})), input),
                        }];
                }
                debug("updateUserPreferences - begin");
                // Update the lastUpdatedPreferences
                this.lastUpdatedPreferences = __assign(__assign({}, (this.lastUpdatedPreferences || {})), input);
                return [2 /*return*/, this._fetch("/api/staffbar/user", {
                        method: "POST",
                        body: JSON.stringify(input),
                    })];
            });
        });
    };
    /**
     * POST - /api/staffbar/bar
     *
     * @param input The updated bar
     * @returns The updated bar
     */
    API.prototype.updateBar = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                debug("updateBar", input);
                return [2 /*return*/, this._fetch("/api/staffbar/bar", {
                        method: "POST",
                        body: JSON.stringify(input),
                    })];
            });
        });
    };
    /**
     * GET - /api/staffbar/bar
     *
     * @returns A Result object containing the current bar state
     */
    API.prototype.getBar = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                debug("getBar");
                return [2 /*return*/, this._fetch("/api/staffbar/bar", {
                        method: "GET",
                    })];
            });
        });
    };
    API.prototype._fetch = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var result, _a, _b, _c, _d, _e, json, e_1;
            var _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _h.trys.push([0, 4, , 5]);
                        _a = fetch;
                        _b = [url];
                        _c = [__assign({}, options)];
                        _f = {};
                        _d = [__assign({}, options.headers)];
                        _g = {};
                        _e = "Bearer ".concat;
                        return [4 /*yield*/, this.tokenProvider._getToken()];
                    case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([__assign.apply(void 0, _c.concat([(_f.headers = __assign.apply(void 0, _d.concat([(_g.Authorization = _e.apply("Bearer ", [_h.sent()]), _g)])), _f)]))]))];
                    case 2:
                        result = _h.sent();
                        return [4 /*yield*/, result.json()];
                    case 3:
                        json = _h.sent();
                        return [2 /*return*/, {
                                ok: true,
                                value: json,
                            }];
                    case 4:
                        e_1 = _h.sent();
                        if (e_1 instanceof Error) {
                            return [2 /*return*/, {
                                    ok: false,
                                    error: {
                                        message: e_1.message,
                                    },
                                }];
                        }
                        return [2 /*return*/, {
                                ok: false,
                                error: {
                                    message: "An unexpected error occurred.",
                                },
                            }];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return API;
}());
exports.default = API;
